import React from 'react';
import FacturesPage from '../components/FacturesPage.jsx';
import * as api from '../api';

export default function FacturesReparation() {
  return (
    <FacturesPage
      title="Factures Atelier"
      fetchFn={api.getFacturesReparation}
      getPdfFn={api.getFactureReparationPdf}
      syncFn={api.syncFactureReparationOdoo}
      deleteFn={api.deleteFactureReparation}
      getDocumentOrigine={f => ({
        label: f.ordre_numero || f.ordre_id || '—',
        href:  f.ordre_id ? `/atelier?ordre_id=${f.ordre_id}` : null,
      })}
    />
  );
}
